export enum InjectionTokens {
  ChannelSelectionService = '@trustedshops/channel-management:ChannelSelectionService',
}
